export default __webpack_public_path__ + "static/media/20251005-AZ204.ce2f02bd.pdf";